import { z } from 'zod';
import { platformOperationalProviderHealthSchema } from '../custom-domains/platform-custom-domain.contract.js';
export const platformSenderIdentityIdSchema = z.string().uuid();
export const platformSenderIdentityVersionSchema = z.number().int().positive();
export const platformSenderIdentityChannelSchema = z.enum(['email', 'sms']);
export const platformSenderIdentityStateSchema = z.enum([
    'pending-verification',
    'verified',
    'disabled',
    'revoked',
    'unavailable',
]);
export const platformEmailSenderAddressSchema = z.string().trim().email().max(254);
export const platformSmsSenderAddressSchema = z.string().trim().max(16).refine((value) => /^\+[1-9][0-9]{7,14}$/.test(value) || /^[A-Za-z0-9][A-Za-z0-9 ]{2,10}$/.test(value), 'SMS sender identity must be E.164 or a 3-to-11-character alphanumeric sender.');
export const platformSenderIdentityReferenceSchema = z.strictObject({
    senderIdentityId: platformSenderIdentityIdSchema,
    version: platformSenderIdentityVersionSchema,
});
export const platformSenderIdentitySchema = z.strictObject({
    id: platformSenderIdentityIdSchema,
    version: platformSenderIdentityVersionSchema,
    channel: platformSenderIdentityChannelSchema,
    displayName: z.string().trim().min(1).max(120),
    senderAddress: z.string().trim().min(1).max(254),
    state: platformSenderIdentityStateSchema,
    providerHealth: platformOperationalProviderHealthSchema,
    verificationExpiresAt: z.string().datetime({ offset: true }).nullable(),
    verifiedAt: z.string().datetime({ offset: true }).nullable(),
    disabledAt: z.string().datetime({ offset: true }).nullable(),
    revokedAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const platformSenderIdentityCreateRequestSchema = z.discriminatedUnion('channel', [
    z.strictObject({
        senderIdentityId: platformSenderIdentityIdSchema.nullable().default(null),
        channel: z.literal('email'),
        displayName: z.string().trim().min(1).max(120),
        senderAddress: platformEmailSenderAddressSchema,
    }),
    z.strictObject({
        senderIdentityId: platformSenderIdentityIdSchema.nullable().default(null),
        channel: z.literal('sms'),
        displayName: z.string().trim().min(1).max(120),
        senderAddress: platformSmsSenderAddressSchema,
    }),
]);
export const platformSenderIdentityVerificationSchema = z.strictObject({
    identityVerified: z.boolean(),
    providerHealth: platformOperationalProviderHealthSchema,
    verificationExpiresAt: z.string().datetime({ offset: true }),
    providerRecordVersion: z.string().trim().min(1).max(500).nullable(),
    checkedAt: z.string().datetime({ offset: true }),
});
export const platformSenderIdentityResponseSchema = z.strictObject({
    data: platformSenderIdentitySchema,
});
export const platformSenderIdentityListResponseSchema = z.strictObject({
    data: z.array(platformSenderIdentitySchema),
});
//# sourceMappingURL=platform-sender-identity.contract.js.map